import * as React from "react";
import { WorkerTypesProvider } from "../workerTypes/context/WorkerTypesContext";
import { Workers } from "./WorkersPage";
import { WorkersProvider } from "./context/WorkersContext";

type Props = {};

const WorkersPage = (props: Props) => {
	return (
		<WorkerTypesProvider>
			<WorkersProvider>
				<Workers />
			</WorkersProvider>
		</WorkerTypesProvider>
	);
};

export default WorkersPage;
